import Button from '@/components/Button';
import DeleteButton from '@/components/DeleteButton';
import { FiArrowLeft, FiPlay, FiX } from '@/components/react-icons/main';
import setQuery from '@/lib/setQuery';
import { useMemo } from 'react';

const SliderHeader = ({ showDelete = false, showRun = false, title, onClose, onDelete, disabled = false }) => {
  const isWorkflowScreen = useMemo(() => window.location.pathname.includes('/workflows/'), []);

  const handleRun = () => {
    onClose?.();
    const el = document.querySelector('[data-title-shortcut="⌘ + Enter"]');
    if (el) {
      el.click();
    }
    setQuery({ stepTab: 'output' });
  };

  if (title) {
    return (
      <div className="slider-header">
        <div className="title">{title}</div>
        <Button className="ghost negative-right close-button" title="Close" icon={FiX} onClick={onClose} />
      </div>
    );
  }
  return (
    <div className="slider-header">
      <Button className="ghost negative-left" title="Close" icon={FiArrowLeft} onClick={onClose} />
      <div className="actions">
        {showRun && isWorkflowScreen && (
          <Button className="outline" title="Run Step" size="sm" icon={FiPlay} onClick={handleRun} disabled={disabled}>
            Run
          </Button>
        )}
        {showDelete && <DeleteButton title="Delete" onClick={onDelete} disabled={disabled} />}
      </div>
    </div>
  );
};

export default SliderHeader;
